import React, { useEffect, useState, PropsWithChildren } from 'react';
import BaseSegmented, { IBaseSegmentedItem } from '../components/BaseSegmented';
import { BaseTitleSVGIcon } from '../components/BaseTitleIcon';
import { InputField } from './InputField';

interface IEMR_Group {
  group: FieldGroup;
  // fields: any;
}

export interface FieldGroup {
  name: string,
  icon: string,
  groupId: string
}
export interface Groups {
  groups: FieldGroup[],
  fields?: InputField[]
}


export default function FlatGroup(props: PropsWithChildren<IEMR_Group>) {
  const { group, ...rest } = props;
  const fullIcon = `/images/${group.icon}`;
  // console.log("Full Icon", fullIcon)
  return (
    <div {...rest}>
      <BaseTitleSVGIcon
        icon={fullIcon}
        title={group.name}
        key={group.groupId}
      />
      {props.children}
    </div>
  );
}

export function TabGroup(props: PropsWithChildren<Groups>) {
  const { groups, fields, ...rest } = props;
  const [tab, setTab] = useState('');
  const [items, setItems] = useState<IBaseSegmentedItem[]>([])

  useEffect(() => {
    if (groups && Array.isArray(groups)) {
      const mapGroups: IBaseSegmentedItem[] = []
      groups.forEach((group, index) => {
        mapGroups.push({
          key: group.groupId,
          title: group.name,
          addClass: `tl-pr-[32px] tl-pl-[32px] ${index==0?'tl-rounded-l-3xl':''} ${(index==groups.length-1)?'tl-rounded-r-3xl':''}`
        })
      })
      setItems(mapGroups)
      setTab(mapGroups[0].key)
    }
  }, [groups])

  return (
    <div {...rest}>
      <div className="tl-grow tl-flex tl-justify-between tl-items-center tl-p-[4px]">
        <BaseSegmented
          tab={tab}
          onClick={(key: string) => {
            setTab(key);
          }}
          items={items}
        />
      </div>
      <div>
        {
          (fields && Array.isArray(fields)) ? fields.map((field, index) => {
            if (field.group === tab) {
              return <div key={index} style={{height:100}}>{field.key}</div>
            } else return null;
          }) : null
        }
      </div>
    </div>
  );
}
